import React from 'react';
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getImageSrc } from "../../../helper/utils";

const _ep_CAROUSEL_BUTTON_LIST_ITEM = ({ item }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (!item?.Url) return;
        if (item.Url.startsWith("http://") || item.Url.startsWith("https://")) {
            window.open(item.Url, "_blank");
        } else {
            navigate(item.Url);
        }
    };

    const isNew = item?.ViewType === "NEW_SPORT_CAT";

    return (
        <Box
            onClick={handleClick}
            sx={{
                display: "flex !important",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                py: 1,
                px: 0.5,
                cursor: "pointer",
                userSelect: "none",
                outline: "none",
                "&:hover .category-box": {
                    transform: "translateY(-4px)",
                    boxShadow: "0 12px 24px -4px rgba(231, 51, 62, 0.25)",
                    borderColor: "primary.main",
                    bgcolor: "action.hover"
                },
                "&:hover .category-img": {
                    transform: "scale(1.08)"
                },
                "&:hover .category-title": {
                    color: "primary.main"
                },
                "&:active .category-box": {
                    transform: "scale(0.93)"
                }
            }}
        >
            {/* ظرف آیکون با گوشه‌های سوپربیضی لوکس و سایه نرم */}
            <Box
                className="category-box"
                sx={{
                    position: "relative",
                    width: { xs: 72, sm: 80 },
                    height: { xs: 72, sm: 80 },
                    borderRadius: "22px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "background.paper",
                    border: "1px solid",
                    borderColor: "divider",
                    boxShadow: "0 8px 20px -4px rgba(0, 0, 0, 0.08), 0 2px 6px -1px rgba(0, 0, 0, 0.04)",
                    transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                    p: 1.5
                }}
            >
                {/* بج شناور جدید */}
                {isNew && (
                    <Box
                        sx={{
                            position: "absolute",
                            top: -6,
                            insetInlineStart: -4,
                            background: "linear-gradient(135deg, #e7333e 0%, #b22831 100%)",
                            color: "#ffffff",
                            fontSize: "0.62rem",
                            fontWeight: 800,
                            borderRadius: "10px",
                            px: 1,
                            py: 0.2,
                            boxShadow: "0 4px 10px rgba(231, 51, 62, 0.4)",
                            letterSpacing: "-0.2px",
                            zIndex: 2,
                            lineHeight: 1.4
                        }}
                    >
                        جدید
                    </Box>
                )}

                {/* تصویر آیکون دسته‌بندی */}
                <Box
                    component="img"
                    className="category-img"
                    src={getImageSrc(item?.multimedia?.Url || item?.Multimedia?.Url, 96)}
                    alt={item?.Title || "دسته‌بندی"}
                    loading="lazy"
                    decoding="async"
                    sx={{
                        width: { xs: 44, sm: 48 },
                        height: { xs: 44, sm: 48 },
                        objectFit: "contain",
                        display: "block",
                        borderRadius:2,
                        boxShadow: " #FFFFFF 0px 0px 1px 16px",
                        transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                    }}
                />
            </Box>

            {/* عنوان دسته‌بندی */}
            <Typography
                className="category-title"
                variant="body2"
                sx={{
                    fontWeight: 700,
                    fontSize: { xs: "0.78rem", sm: "0.84rem" },
                    color: "text.primary",
                    mt: 1,
                    maxWidth: { xs: 84, sm: 92 },
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    transition: "color 0.2s ease"
                }}
            >
                {item?.Title}
            </Typography>
        </Box>
    );
};

export default React.memo(_ep_CAROUSEL_BUTTON_LIST_ITEM);

